"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogGrid = exports.BLOG_GRID_SELECT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const BlogGridView_1 = require("./BlogGridView");
exports.BLOG_GRID_SELECT = {
    slug: true,
    title: true,
    image: true,
    seoDescription: true,
    category: {
        title: true,
        slug: true,
    },
};
function BlogGrid() {
    const [selectedCategory, setSelectedCategory] = (0, react_1.useState)(null);
    const { data: categories } = (0, app_1.useQuery)('getArticleCategories', {
        select: {
            slug: true,
            title: true,
        },
    });
    const { data: articles } = (0, app_1.useQuery)('getArticles', {
        args: {
            category: selectedCategory !== null && selectedCategory !== void 0 ? selectedCategory : undefined,
        },
        select: exports.BLOG_GRID_SELECT,
    });
    if (!categories || !articles) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(BlogGridView_1.BlogGridView, { categories: categories, articles: articles === null || articles === void 0 ? void 0 : articles.map((v) => (Object.assign(Object.assign({}, v), { description: v.seoDescription }))), onCategoryClick: setSelectedCategory }));
}
exports.BlogGrid = BlogGrid;
